import { render, staticRenderFns } from "./ChildrensGuardian.vue?vue&type=template&id=7ddf0c0b&scoped=true"
import script from "./ChildrensGuardian.vue?vue&type=script&lang=js"
export * from "./ChildrensGuardian.vue?vue&type=script&lang=js"
import style0 from "./ChildrensGuardian.vue?vue&type=style&index=0&id=7ddf0c0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddf0c0b",
  null
  
)

export default component.exports